import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _DisbursePaymentsFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3848 9.88218C19.385 10.9016 20.2119 11.7279 21.2314 11.7279C21.568 11.7278 21.8826 11.6362 22.1543 11.4789V17.806C22.1543 19.3354 20.9141 20.5755 19.3848 20.5755H2.76953C1.24012 20.5755 0 19.3354 0 17.806V9.49839H19.3848V9.88218ZM4.61523 15.4984C4.1055 15.4985 3.69238 15.9125 3.69238 16.4222C3.69257 16.9318 4.10562 17.345 4.61523 17.3451H6.46191C6.97143 17.3449 7.38458 16.9317 7.38477 16.4222C7.38477 15.9125 6.97155 15.4986 6.46191 15.4984H4.61523ZM8.76953 15.4984C8.25973 15.4984 7.8457 15.9124 7.8457 16.4222C7.84589 16.9319 8.25985 17.3451 8.76953 17.3451H12.4619C12.9714 17.3449 13.3846 16.9317 13.3848 16.4222C13.3848 15.9125 12.9716 15.4986 12.4619 15.4984H8.76953Z"
        fill={iconColor}
      />
      <Path
        d="M20.5781 3.69077C20.9386 3.33029 21.5233 3.33029 21.8838 3.69077L23.7295 5.53647C24.09 5.89696 24.09 6.48165 23.7295 6.84214C23.369 7.20259 22.7843 7.20261 22.4238 6.84214L22.1543 6.57163V9.88218C22.1541 10.3918 21.7402 10.805 21.2305 10.805C20.7209 10.8049 20.3078 10.3917 20.3076 9.88218V6.57163L20.0371 6.84214C20.0147 6.86457 19.9918 6.88598 19.9678 6.90561C19.9582 6.91346 19.9474 6.91969 19.9375 6.9271C19.5759 7.19886 19.0605 7.17122 18.7314 6.84214C18.3713 6.48165 18.3711 5.89688 18.7314 5.53647L20.5781 3.69077Z"
        fill={iconColor}
      />
      <Path
        d="M18.0791 4.88413C17.3586 5.60498 17.3587 6.77356 18.0791 7.49448C18.1371 7.55246 18.1994 7.60402 18.2627 7.65268H0V6.72983C0 5.20043 1.24012 3.9603 2.76953 3.9603H19.0029L18.0791 4.88413Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const DisbursePaymentsFilledIcon = assignWithoutSideEffects(_DisbursePaymentsFilledIcon, {
  componentId: 'DisbursePaymentsFilledIcon',
});

export default DisbursePaymentsFilledIcon;
